__turbopack_context__.v({
  "controls": "WindowsModal-module__JlxkwG__controls",
  "lottie": "WindowsModal-module__JlxkwG__lottie",
  "main": "WindowsModal-module__JlxkwG__main",
  "text": "WindowsModal-module__JlxkwG__text",
});
